import React from 'react';
import { StylesContext } from '../StylesContext';
export var useStyles = function () { return React.useContext(StylesContext); };
//# sourceMappingURL=useStyles.js.map